/**
 * @generated SignedSource<<1dbe05c764bda75213242157cfba8fe1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TransactionType = "NEGOTIABLE" | "NON_NEGOTIABLE" | "OFF_PLATFORM" | "PRE_AUTH_NEGOTIATION" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type useOfferVisibility_viewer$data = {
  readonly conversationsSolr?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly item: {
          readonly serviceId: string | null;
        } | null;
        readonly transaction: {
          readonly hasCompletedCheckout: boolean | null;
          readonly serviceId: string | null;
          readonly transactionType: TransactionType | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  readonly offerVisibilityFF: boolean | null;
  readonly user?: {
    readonly " $fragmentSpreads": FragmentRefs<"clientAbTestV2_useAbTestV2BuyerUser_user">;
  } | null;
  readonly " $fragmentType": "useOfferVisibility_viewer";
};
export type useOfferVisibility_viewer$key = {
  readonly " $data"?: useOfferVisibility_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useOfferVisibility_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useOfferVisibility_viewer",
  "selections": [
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId"
            },
            {
              "kind": "Literal",
              "name": "buyerTags",
              "value": "activePrivateOffer"
            }
          ],
          "concreteType": "ConversationsSolrConnection",
          "kind": "LinkedField",
          "name": "conversationsSolr",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ConversationsSolrEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Conversation",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Transaction",
                      "kind": "LinkedField",
                      "name": "transaction",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "transactionType",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "hasCompletedCheckout",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Item",
                      "kind": "LinkedField",
                      "name": "item",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "clientAbTestV2_useAbTestV2BuyerUser_user"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": "offerVisibilityFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "offerVisibilityIndicator"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"offerVisibilityIndicator\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "762f19a58538033f2b1c53aa06f35041";

export default node;
